import { Injectable, signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AgencyDetails } from '../../../models/common';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {
  private _agencyDetails = signal<AgencyDetails | null>(null);
  agencyDetails = this._agencyDetails.asReadonly();

  async fetchAgencyDetails(agencyId: string) {
    const baseUrl = environment.BP_URL;
    const url = `${baseUrl}/agencies/details/${agencyId}`;

    const token = localStorage.getItem('permanentToken');

    try {
      if(!token) {
        throw new Error('Token not found');
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          authType: 'Key'
        },
      });
      const data = await response.json();
      const agencyDetails = data.data as AgencyDetails;
      this._agencyDetails.set(agencyDetails);
      return agencyDetails;
    } catch (error: unknown) {
      throw new Error((error as Error).message);
    }
  }

  get agencyLogo() {
    const agencyDetails = this.agencyDetails();
    return agencyDetails?.logo || agencyDetails?.meta?.logo || '';
  }
}
